import { UserAccessSettings } from '../../features/connections/models/feature.model';
import { SubscriptionNames } from '../../features/connections/models/subscriptions';

export interface Customer {
	customerId: string;
	email?: string;
	name?: string;
	phone?: string;
	timeZone?: string;
}

export interface CurrentCustomer {
	accountCount: number;
	customerId: string;
	enterprise: boolean;
	name: string;
	subscriptionType: SubscriptionNames;
	waitingToOnboard: boolean;
	freemiumConnectionUsed: boolean;
	settings: UserAccessSettings;
}

export enum SessionInitializationResourceType {
	connection = 'connection',
}

export enum SessionInitializationAction {
	create = 'create',
	resync = 'resync',
	update = 'update',
	revoke = 'revoke',
}

export interface SessionInitializationParameters {
	resourceType: SessionInitializationResourceType;
	resourceId?: string;
	action: SessionInitializationAction;
	institutionId?: string;
}

export interface WidgetConfig {
	beta: boolean;
	excludedConnectionTypes: string[];
	excludedDataProviderIds: string[];
	excludedInstitutionIds: string[];
	collectAccounts: boolean;
}

export interface Partner {
	id: string;
	name: string;
	slug: string;
}

export interface Session {
	id: string;
	customerId: string;
	expiresAt: string | null;
	initializationParameters: SessionInitializationParameters | null;
	widgetConfig: WidgetConfig;
	partner: Partner;
}
